var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8184 11.6084L10.5029 14.4448C10.4873 14.5859 10.5322 14.7275 10.627 14.8335C10.7227 14.9395 10.8575 15 11 15H13C13.1426 15 13.2774 14.9395 13.373 14.8335C13.4678 14.7276 13.5127 14.586 13.4971 14.4448L13.1817 11.6084C13.6934 11.2359 14 10.6465 14 10C14 8.897 13.1025 8 12 8C10.8974 8 9.99997 8.89695 9.99997 10C9.99997 10.6465 10.3066 11.2359 10.8184 11.6084Z",
    fill: "#4F565E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.00003H12.4999C12.7763 4.00003 13 3.77639 13 3.50002C13 3.22364 12.7763 3 12.4999 3H11.5C11.2236 3 10.9999 3.22364 10.9999 3.50002C11 3.77644 11.2236 4.00003 11.5 4.00003Z",
    fill: "#4F565E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H5.99999C4.89697 0 3.99997 0.896953 3.99997 2.00002V22C3.99997 23.103 4.89697 24 5.99999 24H18C19.103 24 20 23.103 20 22V2.00002C20 0.896953 19.103 0 18 0ZM13.5 22H10.5C10.2236 22 9.99997 21.7763 9.99997 21.5C9.99997 21.2236 10.2236 21 10.5 21H13.5C13.7764 21 14 21.2236 14 21.5C14 21.7764 13.7764 22 13.5 22ZM18 19H5.99999V2.00002H18V19Z",
    fill: "#4F565E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.00003C16.7761 4.00003 17 3.77617 17 3.50002C17 3.22386 16.7761 3 16.5 3C16.2238 3 16 3.22386 16 3.50002C16 3.77617 16.2238 4.00003 16.5 4.00003Z",
    fill: "#4F565E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNumber);
export default __webpack_public_path__ + "static/media/contact-number.1100520ebfd06fd5f7f571484d31bd97.svg";
export { ForwardRef as ReactComponent };